module.exports = __webpack_public_path__ + "static/img/wechat1.6ac4c931.png";